import React, { useEffect, useRef, useState } from "react";
import axios from 'axios';
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import { slideIn, staggerContainer } from "./utils/motion";
import { setSelected } from "../store/reducers/CartReducer";
import { GiPhone } from "react-icons/gi";



export default function Contact  ({lang})  {


  const formRef = useRef();
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });


  const dispatch = useDispatch()
  useEffect(() => {
  dispatch( setSelected({select:4}))
  }, []);

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleSubmit =async (e) => {


    e.preventDefault();
    toast.loading(`Sending...`)
    setLoading(true);
     try {
  
      var formData = new FormData();
       
      formData.append("key",'54c1ba3f7ad809ef60df1e4bafc8f92a'); 
      formData.append("name",form.name); 
      formData.append("email",form.email); 
      formData.append("message",form.message); 
  
      axios.post(`${window.location.origin}/contact.php?`, formData)
      .then(res => {
    toast.remove()
    setLoading(false);
if(res.data.success===true){

  setForm({
    name: "",
    email: "",
    message: "",
  });


  { lang === 'en' ? 
toast.success(`${res.data.msg}`,{duration: 4000,},)
:
toast.success(`شكرا لاتصالك بنا، سوف نقوم بالرد على البريد الإلكتروني الخاص بك في أقرب وقت ممكن`,{duration: 4000,},)

  }
  
}else{
  setForm({
    name: "",
    email: "",
    message: "",
  });

  { lang === 'en' ? 
toast.success(`${res.data.msg}`,{duration: 3000,},)
:
toast.success(`مشكلة الخادم. يرجى المحاولة مرة أخرى`,{duration: 3000,},)

  }
}
     
     


       })
    } catch (error) {
    
      setLoading(false);
      toast.remove()
      toast.error(`${lang === 'en' ? 'Ahh, something went wrong. Please try again.' : 'اه، حدث خطأ ما. يرجى المحاولة مرة أخرى.'}`,{duration: 3000,},)
  
    }    
  
  
  }
  
  return (
     <>
         <motion.div   variants={staggerContainer()}
   initial='hidden'
   whileInView='show'
   viewport={{ amount: 0.25 }} className="  w-[100%] px-[5%] my-[80px]  ">
      <span className='hash-span' id={'Contact'}>
   
   </span>
       <motion.div
        variants={slideIn("left", "tween", 0.2, 1)}
        className=' bg-[#f4f4f4] p-8 rounded-2xl'
      >
     <h2 style={{fontFamily:'CairoExtraBold'}} className={` ${lang === 'en' ? 'text-left' : 'text-right' }  w-full text-primary text-[20px]  lg:text-[50px]  md:text-[40px]  sm:text-[30px]  xs:text-[20px] `} >
     { lang === 'en' ? "Contact us" : "تواصل بنا"}
                      </h2>
     
        <form
          dir={lang=== 'en' ? 'ltr' :'rtl'}
          ref={formRef}
          onSubmit={handleSubmit}
          className='p-4 w-[100%] flex flex-col gap-8   '

        >
       
          
            <input
              type='text'
              name='name'
              value={form.name}
              onChange={handleChange}
              placeholder={lang=== 'en' ? "What's your name?" :'ماهو اسمك ؟'}
              required
              className=' bg-[#ffffff] border-[1px] border-[#323131] py-4 px-6 placeholder:text-[#323131] text-[#323131] rounded-lg outline-none  font-medium'
            />
       
        
            <input
              type='email'
              name='email'
              value={form.email}
              onChange={handleChange}
              required
              placeholder={lang=== 'en' ? "What's your email address?" :'ماهو بريدك الألكتروني ؟'}
                className=' bg-[#ffffff] border-[1px] border-[#323131] py-4 px-6 placeholder:text-[#323131] text-[#323131] rounded-lg outline-none  font-medium'
            />
            
         
            <textarea
              rows={7}
              name='message'
              required
              value={form.message}
              onChange={handleChange}
              placeholder={lang=== 'en' ? 'What you want to say?' :'ماهي رسالتك لنا ؟'}
               className='  bg-[#ffffff] border-[1px] border-[#323131] py-4 px-6 placeholder:text-[#323131] text-[#323131] rounded-lg outline-none  font-medium'
            />
          

          <button
            type='submit'
            className='bg-primary py-3 px-8 rounded-xl outline-none w-fit text-[#ffffff] font-bold shadow-md shadow-primary hover:opacity-70'
          >
            {lang=== 'en' ?
              loading ? "Sending..." : "Send"
              
              
              :
              loading ? "جاري الارسال..." : "ارسال"
              
              }
          </button>

          <ul  className="w-full  px-[5%] gap-1 flex   mt-2 ">
        <li className="m-auto w-[24px] h-[24px] rounded"><a className="" target='__blink' href="Tel:+967779030000">
            <GiPhone color="#E6324B" size={24} />
             </a></li>

             <li className="m-auto w-[24px] h-[24px] rounded"><a className="" target='__blink' href="https://wa.me/+967779030000">
               <img src='../Icons/whatsapp.png ' alt="al-hubaishi whatsapp" name="logo-whatsapp" width={24} height={24}  />
             </a></li>
      
             <li className="m-auto w-[24px] h-[24px] rounded"><a className="" target='__blink' href="mailto:info@al-hubaishi.com">
               <img src='../Icons/gmail.png ' alt="al-hubaishi gmail" name="logo-gmail" width={24} height={24}  />
             </a></li>
          
            
             <li className="m-auto w-[24px] h-[24px] rounded "><a className="" target='__blink' href="https://www.facebook.com/profile.php?id=100076069705620">
          <img src='../Icons/facebook.png ' alt="al-hubaishi facebook" name="logo-facebook" width={24} height={24}  />
        </a></li>
            
             
         </ul>
   
        </form>

        
</motion.div>
     


     
    </motion.div>
    </>
  );
};



